import { Suspense, useCallback, useContext, useEffect, useState } from "react";
import { LazyImage } from "../../../../Services/Decorator_Lazy_Loading/ImageVideoLazyLoding";
import { useFormik } from "formik";
import { TostMsg } from "../../../../App";
import { addSocialMedia, deleteSocial } from "../Service/profileService";
import { GetMasterTypeData } from "../../../../Services/Global-Services/GlobalServices";
import ERROR_LIST from "../../../../Services/Global-Services/Hadle_Errors";
import ComponentLoader from "../../../../Shared/Sidebar/ComponentLoader";

const UserMedia = ({
  employeeAllData,
  employeeId,
  updateEmployeeDetails,
}) => {
  let userDetails = JSON.parse(localStorage.getItem("User") || "{}");
  let userPermissions = JSON.parse(localStorage.getItem("Permissions") || "{}");
  let SystemAlerts = JSON.parse(localStorage.getItem("SystemAlerts") || "{}");
  const toster = useContext(TostMsg);
  const [badgesId, setBadgesId] = useState(0);
  const [employeeCreate, setEmployeeCreate] = useState(false);
  const [showContent, setSeleteContent] = useState([]);
  const [Isloading, setIsloading] = useState(false);
  const [selectedContact, setSelectedContact] = useState([]);
  const [mediaId, setMediaId] = useState([]);
  const [editContactMap, setEditContactMap] = useState({});

  useEffect(() => {
    permissionAccouncementList();
    getMaster();
  }, []);

  const handleClick = () => {
    updateEmployeeDetails();
  };

  const getMaster = async () => {
    let params = {
      masterType: "ContactType",
      allRecords: true,
      organisationId: userDetails?.OrgId,
    };
    try {
      let responce = await GetMasterTypeData(params);
      setSelectedContact(responce?.Data);
    } catch (error) {
      toster.current.error(ERROR_LIST?.MasterDataType);
    }
  };

  const permissionAccouncementList = () => {
    userPermissions.map((UserPermission) => {
      if (UserPermission.PermissionName == "Employee.Create") {
        setEmployeeCreate(true);
      }
    });
  };

  const GetMasterSystemAlertList = useCallback(async (message, type) => {
    SystemAlerts?.filter((msg) => {
      if (msg?.Name == message && type == 0) {
        toster.current.success(msg?.Desc);
      } else if (msg?.Name == message && type == 1) {
        setSeleteContent(msg?.Desc);
      } else if (msg?.Name == message && type == 2) {
        setSeleteContent(msg?.Desc);
      }
    });
  }, []);

  const handleCloseAppreciationModal = () => {
    document.querySelector("#add-media .btn-close")?.click();
    mediaForm.resetForm();
  };

  function editAllMediaFromAPI(apiData) {
    const values = {};
    const idMap = {};
    apiData.forEach((item) => {
      const key = `contact_${item.ContactTypeId}`;
      values[key] = item.Contact || "";
      idMap[item.ContactTypeId] = item.Id;
    });
    mediaForm.setValues((prev) => ({
      ...prev,
      ...values,
    }));
    setEditContactMap(idMap);
  }

  const initialValues = {};
  selectedContact
    ?.filter(
      (option) =>
        option.Id !== 102 &&
        option.Id !== 104 &&
        option.Id !== 113 &&
        option.Id !== 101
    )
    .forEach((option) => {
      initialValues[`contact_${option.Id}`] = "";
    });

  const mediaForm = useFormik({
    initialValues,
    onSubmit: async (data) => {
      setIsloading(true);
      const contactList = Object.entries(data)
        .filter(([key, value]) => key.startsWith("contact_"))
        .map(([key, value]) => {
          const contactTypeId = parseInt(key.replace("contact_", ""), 10);
          const existingId = editContactMap[contactTypeId] || 0;
          return {
            Id: existingId,
            EmpId: userDetails?.EmpId,
            OrgId: userDetails?.OrgId,
            ContactTypeId: contactTypeId,
            Code: "",
            Contact: value,
            ContactDetails: "",
            ContactDescription: "",
            IsVerified: true,
            IsDefaultContact: true,
          };
        });
      try {
        for (const body of contactList) {
          await addSocialMedia(body);
        }
        GetMasterSystemAlertList("Media_Updated", 0);
        document.querySelector("#add-media .btn-close")?.click();
        handleCloseAppreciationModal();
        handleClick();
        setIsloading(false);
      } catch (error) {
        setIsloading(false);
        toster.current.error(ERROR_LIST.DefaultError);
      }
    },
  });


  async function deleteMedia() {
    setIsloading(true);
    if (mediaId) {
      const body = {
        Id: mediaId,
      };
      try {
        setIsloading(false);
        let response = await deleteSocial(body);
        if (response) {
          GetMasterSystemAlertList("Media_Deleted", 0);
          handleClick();
          setIsloading(false);
        }
      } catch (error) {
        setIsloading(false);
        toster.current.error(ERROR_LIST.DefaultError);
      }
    }
  }

  return (
    <>
      <div className="">
        <div className="form-head stuck-headers33 mt-3 social_share_profile_icon mb-3">
          <div className="form-head stuck-header profile-about-me">
            <div className="mb-0">
              <h4 className="text-primary mb-2 sumh4 addprofile-action">
                Social Media
                {userDetails?.EmpId == employeeId && (
                  <span>
                    <a
                      className="edit-btncss mb-2 love-icon"
                      data-bs-toggle="modal"
                      aria-label="Media"
                      data-bs-target="#add-media"
                      title="Add"
                      onClick={() => {
                        editAllMediaFromAPI(employeeAllData[0]?.Contacts);
                        GetMasterSystemAlertList("Update_Social", 1);
                      }}
                    >
                      <img src="/images/org-img/edit.png" className="" />
                    </a>
                  </span>
                )}
              </h4>
              <div className="languages-wrapper90">
                {employeeAllData[0]?.Contacts?.map(
                  (data) =>
                    (data?.ContactTypeId === 114 ||
                      data?.ContactTypeId === 115 ||
                      data?.ContactTypeId === 116 ||
                      data?.ContactTypeId === 117) &&
                    data?.Contact != "" && (
                      <>
                        <div className="languages-item social-share">
                          <a
                            target="_blank"
                            href={data.Contact}
                            title={data?.ContactType}
                          >
                            <div className="icon-wrap col-sm-2">
                              <LazyImage src={data?.Iconpath} />
                            </div>
                          </a>
                          {userDetails?.EmpId == employeeId && (
                            <div className="meta col-sm-10">
                              {" "}
                              <div className="hover-badges-box">
                                <img
                                  onClick={() => {
                                    setMediaId(data?.Id);
                                    GetMasterSystemAlertList("Delete_Media", 1);
                                  }}
                                  src="/images/org-img/delete.png"
                                  className=""
                                  title="Delete"
                                  data-bs-toggle="modal"
                                  data-bs-target="#delete-Media"
                                />
                              </div>
                            </div>
                          )}
                        </div>
                      </>
                    )
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        className="modal fade custom-modal-area"
        id="add-media"
        tabIndex="-1"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content add-editbadge">
            <div className="modal-header">
              <img
                src="/images/org-img/leave/popup-backimg.png"
                className="backimg"
              />
              <div className="img">
                <img src="/images/popup-icons/featured-post.png" />
              </div>
              <button
                onClick={handleCloseAppreciationModal}
                type="button"
                className="btn-close m-auto"
                data-bs-dismiss="modal"
              ></button>
            </div>
            <div className="modal-body ">
              <div className="text-center">
                <div className="modal-title ">
                  {badgesId != 0 ? (
                    <h5 className="modal-title m-auto">Edit Media</h5>
                  ) : (
                    <h5 className="modal-title m-auto">Add Social Media</h5>
                  )}
                </div>
                <p>{showContent}</p>
              </div>
              <div className="addcourseform">
                <form onSubmit={mediaForm.handleSubmit}>
                  {selectedContact
                    ?.filter(
                      (option) =>
                        option.Id !== 102 &&
                        option.Id !== 104 &&
                        option.Id !== 113 &&
                        option.Id !== 101
                    )
                    .map((option) => (
                      <div className="row" key={option.Id}>
                        <div className="mb-2 col-md-12 mt-1">
                          <label className="form-label">{option?.Name}</label>
                          <input
                            pattern="https?://.+"
                            type="url"
                            name={`contact_${option.Id}`}
                            placeholder="URL"
                            className="form-control"
                            onChange={mediaForm.handleChange}
                            value={
                              mediaForm.values[`contact_${option.Id}`] || ""
                            }
                          />
                        </div>
                      </div>
                    ))}
                  <div className="modal-footer m-auto justify-content-center">
                    <button
                      type="button"
                      className="cancelbtn-click"
                      data-bs-dismiss="modal"
                      onClick={handleCloseAppreciationModal}
                    >
                      Cancel
                    </button>
                    {badgesId != 0 ? (
                      <button type="submit" className="savebtn-click">
                        Update
                      </button>
                    ) : (
                      <button
                        type="submit"
                        className="savebtn-click"
                        disabled={Isloading}
                      >
                        {Isloading ? "Saving..." : "Save & exit"}
                      </button>
                    )}
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="modal fade custom-modal-area" id="delete-Media">
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content delete-holiday">
            <div className="modal-header">
              <img
                src="/images/org-img/leave/popup-backimg.png"
                className="backimg"
              />
              <div className="img">
                <img src="/images/org-img/leave/trash.png" />
              </div>
            </div>
            <div className="modal-body text-center">
              <strong className="modal-title">Are you sure?</strong>
              <p>{showContent}</p>
            </div>
            <div className="modal-footer m-auto">
              <button
                type="button"
                className="cancelbtn-click"
                data-bs-dismiss="modal"
              >
                Cancel
              </button>
              <button
                type="button"
                className="deletebtn-click"
                data-bs-dismiss="modal"
                onClick={() => deleteMedia()}
              >
                Delete
              </button>
            </div>
          </div>
        </div>
      </div>
      {Isloading ? (
        <Suspense>
          <ComponentLoader />
        </Suspense>
      ) : (
        ""
      )}
    </>
  );
};

export default UserMedia;
